import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';


@Component({
    selector: 'app-team-select',
    template: `
<form [formGroup]="teamSelectForm">
  <mat-form-field class="flex-1">
    <mat-label>Assign to team</mat-label>
    <mat-select formControlName="assignedToTeamId"  #str (selectionChange)="onTeamSelect(str.value)">
      @for (order of team; track order; let i = $index) {
        <mat-option [value]="team[i].teamId">
          {{team[i].name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
`,
    styles: [],
    standalone: false
})
export class TeamSelectComponent implements OnInit, OnChanges
{

	teamSelectForm: UntypedFormGroup;
	formLoading = false;
	team = [];
	@Output() messageEvent = new EventEmitter<string>();

	@Input() taskId: number;

	@Input() assignedToTeamId: number;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private taskService: TaskService,
		private alertService: AlertService) { }
	ngOnInit()
	{
		this.teamSelectForm = this.formBuilder.group({
			assignedToTeamId: [this.assignedToTeamId],
			taskId: [this.taskId]
		});

		this.findTeams();

		// console.log('kkk are: ' + this.assignedToTeamId);
	}
	findTeams()
	{
		this.reportService.teamSummaryList().pipe(first()).subscribe(

			data =>
			{
				// console.log('reports are: ' + JSON.stringify(data));
				this.team = data.data.teamSummaryList;
				// console.log('QA: ' + JSON.stringify(this.team));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}


	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			// console.log('Form Submitted: ' + JSON.stringify(this.teamSelectForm.value));
			if (this.teamSelectForm.invalid)
			{
				// console.log('Form Invalid: ' + JSON.stringify(this.teamSelectForm.getError));
				return;
			}

			this.formLoading = true;
			this.taskService.updateAssignedToTeamId(this.teamSelectForm.value)
				.subscribe(
					data =>
					{
						// console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(data, true);
						// this.router.navigate(['/task-view', this.form1.value.taskId]);
					},
					err =>
					{
						// console.log('Task-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**
		 *
		 * method to update parent component
		 */


	onTeamSelect(value)
	{
		// console.log('Team Fired1 ' + value);
		// update
		if (this.taskId == null)
		{
			this.alertService.error('Please enter a task name first');
		}
		else
		{
			this.formUpdate();
		}
		this.messageEvent.emit(this.teamSelectForm.value);
	}

	/**
		 *
		 * helper method to update this component from parent
		 */
	setTeamId(assignedToTeamId: number)
	{
		// console.log('assignedToTeamId Fired2 ' + assignedToTeamId);
		this.assignedToTeamId = assignedToTeamId;
	}

	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.teamSelectForm !== undefined)
		{
			this.teamSelectForm.patchValue({ taskId: this.taskId });
		}
	}
}
